module.exports = __webpack_public_path__ + "img/icon-question-radiobutton_active.d44e0320.svg";